import { useSnackbar as useSnackbarBase, setSnackbar } from '../../components/context/snackbar';

const useSnackbar = () => {
  const currentSnackbar = useSnackbarBase();

  return { currentSnackbar, setSnackbar };
};

export default useSnackbar;
